<template>
  <div>
    <el-form class="aging-filter" :model="query" label-width="72px" @keyup.enter.native="load">
      <el-form-item label="截止日期">
        <el-date-picker v-model="query.asOfDate" type="date" value-format="yyyy-MM-dd" size="small" style="width:100%" />
      </el-form-item>
      <el-form-item label="客户编码"><el-input v-model="query.partnerCode" size="small" clearable /></el-form-item>
      <el-form-item label="客户名称"><el-input v-model="query.partnerName" size="small" clearable /></el-form-item>
      <el-form-item label="视图">
        <el-select v-model="query.summaryOnly" size="small" style="width:100%">
          <el-option label="汇总+明细" :value="false" />
          <el-option label="仅汇总" :value="true" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('finance:receivableAging:list')" type="primary" size="small" @click="load">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="aging-note">期初为汇总余额，缺少原始单据日期时列入“期初未分龄”；同一客户仅采用截止日最近年度的期初。</div>
    <el-table :data="list" border v-loading="loading" show-summary :summary-method="summaries" :row-class-name="rowClass" :header-cell-style="headStyle">
      <el-table-column prop="partnerCode" label="客户编码" width="110" />
      <el-table-column prop="partnerName" label="客户名称" min-width="140" />
      <el-table-column prop="billCode" label="单据号" min-width="190">
        <template slot-scope="s">
          <div class="aging-bill-code">
            <span>{{ s.row.billCode }}</span>
            <el-tooltip v-if="Number(s.row.sourceInvalid) > 0" content="发票表头金额与有效明细不符，请核查历史数据" placement="top">
              <el-tag type="warning" size="mini">明细异常</el-tag>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="billDate" label="单据日期" width="110" align="center" />
      <el-table-column prop="ageDays" label="账龄(天)" width="90" align="center" />
      <el-table-column prop="remainAmount" label="未结金额" width="110" align="right"><template slot-scope="s">{{ money(s.row.remainAmount) }}</template></el-table-column>
      <el-table-column prop="bucketUnaged" label="期初未分龄" width="120" align="right"><template slot-scope="s">{{ money(s.row.bucketUnaged) }}</template></el-table-column>
      <el-table-column prop="bucket0To30" label="0-30天" width="100" align="right"><template slot-scope="s">{{ money(s.row.bucket0To30) }}</template></el-table-column>
      <el-table-column prop="bucket31To60" label="31-60天" width="100" align="right"><template slot-scope="s">{{ money(s.row.bucket31To60) }}</template></el-table-column>
      <el-table-column prop="bucket61To90" label="61-90天" width="100" align="right"><template slot-scope="s">{{ money(s.row.bucket61To90) }}</template></el-table-column>
      <el-table-column prop="bucket91To180" label="91-180天" width="110" align="right"><template slot-scope="s">{{ money(s.row.bucket91To180) }}</template></el-table-column>
      <el-table-column prop="bucketOver180" label="180天以上" width="110" align="right"><template slot-scope="s">{{ money(s.row.bucketOver180) }}</template></el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '../../api/request'
import auth from './financeAuth'

export default {
  mixins: [auth],
  data() { return { query: { asOfDate: '', partnerCode: '', partnerName: '', summaryOnly: false }, list: [] } },
  created() { this.query.asOfDate = this.today(); this.load() },
  methods: {
    load() {
      this.loading = true
      request.get('/finance/aging/list', { params: { kind: 'receivable', asOfDate: this.query.asOfDate, partnerCode: this.query.partnerCode, partnerName: this.query.partnerName, summaryOnly: this.query.summaryOnly } })
        .then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    rowClass({ row }) { return row.rowType === 'summary' ? 'aging-summary-row' : '' },
    summaries({ columns, data }) {
      const fields = ['remainAmount', 'bucketUnaged', 'bucket0To30', 'bucket31To60', 'bucket61To90', 'bucket91To180', 'bucketOver180']
      return columns.map((col, index) => {
        if (index === 0) return '合计'
        if (fields.indexOf(col.property) < 0) return ''
        const total = data.filter(row => row.rowType === (data.some(item => item.rowType === 'detail') ? 'detail' : 'summary'))
          .reduce((sum, row) => sum + Number(row[col.property] || 0), 0)
        return total.toFixed(2)
      })
    }
  }
}
</script>

<style scoped>
.aging-filter { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 8px 16px; margin-bottom: 14px; }
.aging-note { color: #909399; font-size: 12px; margin: -4px 0 10px; }
::v-deep .aging-filter .el-form-item { display: flex; min-width: 0; margin: 0; }
::v-deep .aging-filter .el-form-item__label { flex: 0 0 72px; padding-right: 8px; }
::v-deep .aging-filter .el-form-item__content { flex: 1; min-width: 0; margin-left: 0 !important; }
::v-deep .aging-filter .el-form-item__content > .el-input { width: 100%; }
::v-deep .aging-filter .el-form-item:last-child { padding-left: 72px; }
::v-deep .aging-summary-row { background: #f0f9ff; font-weight: 600; }
.aging-bill-code { display: flex; align-items: center; gap: 6px; white-space: nowrap; }
</style>
